import { addLabel, createButton, round_price, literal_price_with_check_zero_fractional_part } from './common/ui'

function getBetValue (value, precisionCeil) {
    // расскоментить, если нужно все ставки округлять(пока что округлять можно только при делении/умножении и потенциальный выигрыш(это для игр типа лесенка))
    // цитата: "если минимальная ставка - меньше целого, а окргуление включено - это проблеммы сервера
    // ВАМ строго нельзя чтото додумывать и исправлять. задача клиента - показать информацию как есть"
    // return round_price(value, precisionCeil);
    return value;
}

export class UiPanel extends PIXI.Container
{
    constructor(config = configUiPanel_mobile_vertical) {

        super();

        const packFolder = config.packFolder;

        this.config = config;

        let self = this;

        this.onTotalBetChanged = ()=>{};
        this.onDigitPanelMove = ()=>{};

        let addLabelConfig = function (parent, cfgFont) {
            const x = cfgFont.pos.x;
            const y = cfgFont.pos.y;
            const ax = cfgFont.font.anchor      !== undefined ? cfgFont.font.anchor.x : 0.5;
            const ay = cfgFont.font.anchor      !== undefined ? cfgFont.font.anchor.y : 0.5;
            const align = cfgFont.font.align    !== undefined ? cfgFont.font.align : "center";
            const tint = cfgFont.font.tint      !== undefined ? cfgFont.font.tint : 0xffffff;
            return addLabel(parent, x, y, cfgFont.font.name, align, ax, ay, tint);
        };

        this.sndBtnClick = sounds.get(config.sndBtnClick);
        this.sndPlayClick = sounds.get(config.sndBtnPlay);
        const snd = this.sndBtnClick;

        this.widthBetButtonTextArea     = config.widthBetButtonTextArea;
        this.widthTotalBetTextArea      = config.widthTotalBetTextArea;
        this.widthCreditsTextArea       = config.widthCreditsTextArea;

        this.lengthAreaForBetsButtons   = config.lengthAreaForBetsButtons;
        this.lengthBetButton            = config.lengthBetButton;
        this.offsetBetweenBetButtons    = config.offsetBetweenBetButtons;
        this.startBetButtonsPos         = config.startBetButtonsPos;
        this.isVerticallyDirection      = config.isVerticallyDirection;
        this.isNoDivMulButtons          = config.isNoDivMulButtons;
        this.isNoMinMaxButtons          = config.isNoMinMaxButtons;
        this.isMobileMode               = config.isMobileMode;
        this.isAccumulateBetMode        = config.isAccumulateBetMode;

        this.currency = 'RUB';
        this.currencyPrecision = 0;
        this.currencyDelimiter = '.';
        this.currencyPrecisionCeil = 0;

        this.minBet = 0;
        this.maxBet = 0;

        this.isInitState = false;

        this.layerPanel = new PIXI.Container();
        this.addChild(this.layerPanel);

        this.layerBetButtons = new PIXI.Container();

        let parent = this;

        this.isMobileHorozontal = config.screenWidth > 540 && this.isMobileMode;

        this.buttonPlaceBet = createButton(parent, config.buttonPlaceBetPosition.x,  config.buttonPlaceBetPosition.y, packFolder + "place_bet", this.sndPlayClick, true);
        this.buttonPlaceBet.enabled = false;

        if (this.isMobileHorozontal) {
            parent.removeChild(this.buttonPlaceBet);
            this.layerPanel.addChild(this.buttonPlaceBet);
        }

        // disable digital panel
        if (config.isMobileMode) {
            this.labelPlaceBet = addLabel(this.buttonPlaceBet, config.buttonPlaceBetTextPos.x, config.buttonPlaceBetTextPos.y, "font_place_button_bet_panel_mobile_vertical");
            this.labelPlaceBet.text = config.buttonPlaceBetText;
            this.labelPlaceBet.scale = config.buttonPlaceBetTextScale;

            this.layerBlockInput = new PIXI.Sprite(new PIXI.Texture(PIXI.Texture.EMPTY, new PIXI.Rectangle(0, 0, config.screenWidth, config.screenHeight)));
            this.layerBlockInput.position.set(0, 0);
            this.layerBlockInput.interactive = true;     // block interactive of overlaid buttons
            this.layerBlockInput.visible = false;
            this.addChild(this.layerBlockInput);

            // переносим поверх layerBlockInput
            this.removeChild(this.layerPanel);
            this.addChild(this.layerPanel);

            this.backDigitalPanel = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "digital_panel/back.png"]);
            let digitalPanelX = 0;
            let digitalPanelUpY = 464;
            let digitalPanelDownY = 721;
            if (this.isMobileHorozontal) {
                digitalPanelX = 688;
                digitalPanelUpY = 86;
                digitalPanelDownY = -277;


                // fix: видна цифравая панель сверху за пределами экрана в горизонтальной версии в вертикальной ориентации
                const mask = new PIXI.Graphics();
                mask.beginFill(0xFFFFFF);
                mask.drawRect(digitalPanelX, 0, this.backDigitalPanel.width, config.screenHeight);
                mask.endFill();
                this.layerPanel.addChild(mask);
                this.layerPanel.mask = mask;
            }
            this.backDigitalPanel.position.set(digitalPanelX, digitalPanelUpY);
            this.backDigitalPanel.interactive = true;     // block interactive of overlaid buttons
            this.layerPanel.addChild(this.backDigitalPanel);

            parent = this.backDigitalPanel;

            // теперь кнопка ввода ставки также скрывает панель, но отдельную кнопку скрытия панели(digitalBtnPanelDown) не стал удалять
            this.digitalBtnPanelDown = createButton(this.backDigitalPanel, 165, 13, packFolder + "digital_panel/panel_down", snd);
            this.digitalBtnPanelUp = createButton(this.backDigitalPanel, 335, 13, packFolder + "digital_panel/panel_up", snd);

            if (this.isMobileHorozontal) {
                // скрывть кнопку
                this.digitalBtnPanelDown.position.set(-1000, 1000);

                this.backDigitalPanel.removeChild(this.digitalBtnPanelUp);
                this.addChild(this.digitalBtnPanelUp);
                this.digitalBtnPanelUp.position.set(693, 20);
            }

            // on start - visible
            // this.backDigitalPanel.position.set(digitalPanelX, digitalPanelUpY);
            // this.digitalBtnPanelUp.visible = false;

            // on start - hide
            this.backDigitalPanel.position.set(digitalPanelX, digitalPanelDownY);
            this.digitalBtnPanelDown.visible = false;

            let panelDigitalCbc = function (isUp) {
                let obj = self.backDigitalPanel;

                if (obj.moveTween) obj.moveTween.stop();

                self.digitalBtnPanelDown.visible = self.digitalBtnPanelUp.visible = false;

                let yTo = 0;
                if (isUp) {
                    yTo = digitalPanelUpY;
                    self.digitalBtnPanelDown.visible = true;
                }
                else {
                    yTo = digitalPanelDownY;
                    self.digitalBtnPanelUp.visible = true;
                }

                obj.moveTween = new TWEEN.Tween(obj.position)
                    .to({y: yTo}, 200)
                    .onComplete(function () {
                        //
                    })
                    .start();

                // если игрок ввел недопустимую ставку, то сбрасываем на текущую
                self._setLabelTotalBet(self.labelTotalBet.betValue);
            };

            let moveBetsButtons = function (pos) {
                let obj = self.layerBetButtons;

                if (obj.moveTween) obj.moveTween.stop();

                obj.moveTween = new TWEEN.Tween(obj.position)
                    .to(self.isMobileHorozontal ? {x: -pos} : {y: pos}, 200)
                    .start();
            };

            this.digitalBtnPanelDown.callback = function () {
                panelDigitalCbc(false);
                moveBetsButtons(0);
                // при скрытии панели - скрываем кнопку ввода ставки
                self.digitalBtnEnter.visible = false;
                self.layerBlockInput.visible = false;
                self.onDigitPanelMove(false);
            };
            this.digitalBtnPanelUp.callback = function () {
                panelDigitalCbc(true);
                moveBetsButtons(100);
                // при показе панели - показываем кнопку ввода ставки
                self.digitalBtnEnter.visible = true;
                self.layerBlockInput.visible = true;
                self.onDigitPanelMove(true);
            };

            let arrX = [143, 226, 309];
            let arrY = [94, 177, 260, 343];

            if (this.isMobileHorozontal) {
                arrX = [2, 71, 140];
                arrY = [12, 81, 150, 219];
            }

            this.arrDigitButtons = [];
            this.arrDigitButtons.push(createButton(this.backDigitalPanel, arrX[1], arrY[3], packFolder + "digital_panel/0", snd));
            this.arrDigitButtons.push(createButton(this.backDigitalPanel, arrX[0], arrY[0], packFolder + "digital_panel/1", snd));
            this.arrDigitButtons.push(createButton(this.backDigitalPanel, arrX[1], arrY[0], packFolder + "digital_panel/2", snd));
            this.arrDigitButtons.push(createButton(this.backDigitalPanel, arrX[2], arrY[0], packFolder + "digital_panel/3", snd));
            this.arrDigitButtons.push(createButton(this.backDigitalPanel, arrX[0], arrY[1], packFolder + "digital_panel/4", snd));
            this.arrDigitButtons.push(createButton(this.backDigitalPanel, arrX[1], arrY[1], packFolder + "digital_panel/5", snd));
            this.arrDigitButtons.push(createButton(this.backDigitalPanel, arrX[2], arrY[1], packFolder + "digital_panel/6", snd));
            this.arrDigitButtons.push(createButton(this.backDigitalPanel, arrX[0], arrY[2], packFolder + "digital_panel/7", snd));
            this.arrDigitButtons.push(createButton(this.backDigitalPanel, arrX[1], arrY[2], packFolder + "digital_panel/8", snd));
            this.arrDigitButtons.push(createButton(this.backDigitalPanel, arrX[2], arrY[2], packFolder + "digital_panel/9", snd));


            this.digitalPanelTotalBetStr = '';
            this.digitalPanelTotalBetVal = 0;
            let digitCbc = function (inputDigOrDot) {
                if (inputDigOrDot === 'del') {
                    if (self.digitalPanelTotalBetStr.length > 0) {
                        self.digitalPanelTotalBetVal = 0;
                        // удаляем последний символ
                        self.digitalPanelTotalBetStr = self.digitalPanelTotalBetStr.slice(0, -1);
                        // удаляем предпоследний символ и повторно его вводим для пересчета
                        if (self.digitalPanelTotalBetStr.length > 0) {
                            let repeatInputValue = self.digitalPanelTotalBetStr[self.digitalPanelTotalBetStr.length - 1];
                            self.digitalPanelTotalBetStr = self.digitalPanelTotalBetStr.slice(0, -1);
                            digitCbc(repeatInputValue);

                            return;
                        }
                        // удалили последний введенный символ - возвращаем ставку до начала ввода
                        else {
                            self._setLabelTotalBet(self.labelTotalBet.betValue);
                        }
                    }
                }

                // TODO: возможно вначале включать все кнопки, а потом по условиям их отключать
                // если есть дробная часть(копейки, центы)
                if (self.currencyPrecision > 0) {
                    let dotInd = self.digitalPanelTotalBetStr.indexOf('.');
                    let countDigitsInFractionalPart = dotInd > 0 ? self.digitalPanelTotalBetStr.length - 1 - dotInd : 0;

                    // нельзя начинать ставку с точки
                    if (self.digitalPanelTotalBetStr === '' && inputDigOrDot === '.') return;

                    // нельзя вводить больше одной точки
                    if (dotInd > 0 && inputDigOrDot === '.') return;

                    // нельзя вводить точку, если уже максимально возможная ставка
                    if ((self.digitalPanelTotalBetVal === self.maxBet || self.digitalPanelTotalBetVal === self.labelCredits.creditsValue) && inputDigOrDot === '.') return;

                    // нельзя вводить ничего кроме точки, если в строке есть только ноль
                    if (self.digitalPanelTotalBetStr.length === 1 && self.digitalPanelTotalBetStr[0] === '0' && inputDigOrDot !== '.') return;

                    // нельзя вводить в дробной части цифр больше, чем точность валюты
                    if (countDigitsInFractionalPart === self.currencyPrecision) return;

                    // нельзя вводить в дробной части все нули
                    if (self.digitalPanelTotalBetVal === 0 && countDigitsInFractionalPart === self.currencyPrecision - 1 && inputDigOrDot === '0') return;

                    // пока пользователь не ввел значение больше нуля - отображаем строку без проверок
                    if (self.digitalPanelTotalBetVal === 0 && (inputDigOrDot === '0' || inputDigOrDot === '.')) {
                        self.digitalPanelTotalBetStr += inputDigOrDot;
                        self.labelTotalBet.text = self.digitalPanelTotalBetStr;

                        // при this.digitalPanelTotalBetVal = 0;
                        self._unlockBets();

                        return;
                    }
                }
                else {
                    // нельзя вводить точку, если у валюты нет дробной части
                    if (inputDigOrDot === '.') return;
                    // нельзя начинать ставку с нуля, если у валюты нет дробной части
                    if (self.digitalPanelTotalBetStr === '' && inputDigOrDot === '0') return;
                }

                let newDigitalPanelTotalBetStr = self.digitalPanelTotalBetStr + inputDigOrDot;

                let dotInd = newDigitalPanelTotalBetStr.indexOf('.');
                let countDigitsInFractionalPart = dotInd > 0 ? newDigitalPanelTotalBetStr.length - 1 - dotInd : 0;

                let k = self.currencyPrecision > 0 ? Math.pow(10, self.currencyPrecision) : 1;
                let l = self.currencyPrecision > 0 ? Math.pow(10, self.currencyPrecision - countDigitsInFractionalPart) : 0;
                let integerStr      = '0';
                let fractionalStr   = '0';

                if (countDigitsInFractionalPart > 0) {
                    integerStr      = newDigitalPanelTotalBetStr.substring(0, newDigitalPanelTotalBetStr.indexOf('.'));
                    fractionalStr   = newDigitalPanelTotalBetStr.substring(newDigitalPanelTotalBetStr.indexOf('.') + 1);
                }
                else {
                    integerStr = newDigitalPanelTotalBetStr;
                }
                let integerValue    = parseInt(integerStr);
                let fractionalValue = parseInt(fractionalStr);

                let newTotalBet = integerValue * k + fractionalValue * l;

                if (newTotalBet <= self.maxBet && newTotalBet <= self.labelCredits.creditsValue) {
                    self.digitalPanelTotalBetStr = newDigitalPanelTotalBetStr;
                    self.digitalPanelTotalBetVal = newTotalBet;
                    self.labelTotalBet.text = newDigitalPanelTotalBetStr;
                    self._scaleTextForArea(self.labelTotalBet, self.widthTotalBetTextArea);

                    self._unlockBets();
                }
            };

            for (let i = 0; i < this.arrDigitButtons.length; ++i) {
                this.arrDigitButtons[i].callback = function () {
                    digitCbc(i.toString())
                };
            }

            this.digitalBtnDot = createButton(this.backDigitalPanel, arrX[0], arrY[3], packFolder + "digital_panel/dot", snd);
            this.digitalBtnDot.callback = function () {
                digitCbc('.');
            };

            this.digitalBtnClear = createButton(this.backDigitalPanel, arrX[2], arrY[3], packFolder + "digital_panel/clear", snd);
            this.digitalBtnClear.callback = function () {
                digitCbc('del');
            };

            this.digitalBtnEnter = createButton(this.backDigitalPanel, 165, 13, packFolder + "digital_panel/enter", snd);
            this.digitalBtnEnter.callback = function () {
                let newTotalBet = self.labelTotalBet.betValue;
                // если пользователь ввел значение ставки
                if (self.digitalPanelTotalBetVal !== 0) {
                    newTotalBet = Math.max(self.minBet, self.digitalPanelTotalBetVal);
                }
                if (newTotalBet !== self.labelTotalBet.betValue)
                    self._lightBetVisible(false);
                self._setLabelTotalBet(newTotalBet);
                self.digitalBtnPanelDown.callback();
            };
            this.layerBlockInput.on('pointerup', function () {
                snd.play();
                self.digitalBtnEnter.callback();
            });

            if (this.isMobileHorozontal) {
                this.digitalBtnEnter.position.set(75, 297);
            }

            this.backDownDigitalPanel = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "digital_panel/back_down.png"]);
            this.backDownDigitalPanel.position.set(0, 801);
            this.backDownDigitalPanel.interactive = true;     // block interactive of overlaid buttons
            this.layerBetButtons.addChild(this.backDownDigitalPanel);

            if (this.isMobileHorozontal) {
                this.backDownDigitalPanel.position.set(688, -1);
                this.layerBetButtons.removeChild(this.backDownDigitalPanel);
                this.layerPanel.addChild(this.backDownDigitalPanel);
            }
        }






        this.backPanel = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "balance_tab.png"]);
        this.backPanel.position = config.balanceTabPosition;
        this.addChild(this.backPanel);

        this.addChild(this.layerBetButtons);

        let arrBetsValue = [0, 100, 500, 1000, 5000, 10000, 25000];
        this.arrBetsButtons = [];
        for(let i = 0; i < arrBetsValue.length; ++i) {
            let btn         = createButton(this.layerBetButtons, 0, 0, packFolder + "bet", snd, true);
            btn.betLabel    = addLabelConfig(btn, config.labelBetButton);

            this.arrBetsButtons.push(btn);
        }

        for (let obj of this.arrBetsButtons) {
            obj.callback = function() {
                self._onBetButton(obj);
            };
        }

        this.labelCredits = addLabelConfig(this.backPanel, config.labelCredits);
        this.labelCredits.text = " ";
        this.labelCredits.creditsValue = -1;

        this.labelCurrencyCredits = addLabelConfig(this.backPanel, config.labelCurrencyCredits);
        this.labelCurrencyCredits.visible = !config.isHideCurrencyCredits;

        this.labelTotalBet = addLabelConfig(this.isMobileHorozontal ? this : parent, config.labelTotalBet);
        this.labelTotalBet.betValue = 0;
        this.labelTotalBet.text = " ";

        this.labelCurrencyTotalBet = addLabelConfig(this.isMobileHorozontal ? this : parent, config.labelCurrencyTotalBet);
        this.labelCurrencyTotalBet.text = "RUB";

        this.labelTotalBet.visible = !config.isHideTotalBet;
        this.labelCurrencyTotalBet.visible = !config.isHideTotalBet;

        if (!this.isMobileHorozontal) {
            parent.removeChild(this.buttonPlaceBet);
            parent.addChild(this.buttonPlaceBet);
        }

        if (!this.isNoMinMaxButtons) {
            this.buttonMin = createButton(parent, config.buttonMinPosition.x, config.buttonMinPosition.y, packFolder + "min_bet", snd, true);
            this.buttonMax = createButton(parent, config.buttonMaxPosition.x, config.buttonMaxPosition.y, packFolder + "max_bet", snd, true);

            this.buttonMin.callback = function () {
                self._onBetButtonMin(self.buttonMin);
            };
            this.buttonMax.callback = function () {
                self._onBetButtonMax(self.buttonMax);
            };
        }

        // в мобильной панеле показываем, но делаем их прозрачными, если !this.isAccumulateBetMode
        if (this.isAccumulateBetMode || config.isMobileMode) {

            this.buttonClearTotalBet    = createButton(parent, config.buttonClearTotalBetPosition.x, config.buttonClearTotalBetPosition.y, packFolder + "clear", snd, true);
            this.buttonClearTotalBet.callback = function () {
                self._setLabelTotalBet(0);
            };

            if (this.isMobileHorozontal) {
                parent.removeChild(this.buttonClearTotalBet);
                this.addChild(this.buttonClearTotalBet);
                this.buttonClearTotalBet.position.set(831, 20);
            }

            if (!this.isNoDivMulButtons) {
                this.buttonDiv = createButton(parent, config.buttonDivPosition.x, config.buttonDivPosition.y, packFolder + "2div", snd, true);
                this.buttonMul = createButton(parent, config.buttonMulPosition.x, config.buttonMulPosition.y, packFolder + "2mul", snd, true);

                this.buttonDiv.callback = function () {
                    self._onButtonDiv();
                };
                this.buttonMul.callback = function () {
                    self._onButtonMul();
                };
            }

            if (config.isMobileMode && !this.isAccumulateBetMode) {
                this.buttonClearTotalBet.enabled = false;
            }
        }

        if (!this.isAccumulateBetMode) {
            this.lightBet = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "bet/light.png"]);
            this.lightBet.label = addLabelConfig(this.lightBet, config.labelBetLight);

            this.lightBet.visible = false;
            this.addChild(this.lightBet);

            if (!this.isNoMinMaxButtons) {
                this.lightBetMin = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "min_bet/light.png"]);
                this.lightBetMin.visible = false;
                parent.addChild(this.lightBetMin);

                this.lightBetMax = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "max_bet/light.png"]);
                this.lightBetMax.visible = false;
                parent.addChild(this.lightBetMax);
            }
        }

        // переносим кнопку ввода ставки цифровой панели на передний слой
        if (this.isMobileMode) {
            this.backDigitalPanel.removeChild(this.digitalBtnEnter);
            this.backDigitalPanel.addChild(this.digitalBtnEnter);
            this.digitalBtnEnter.visible = false;
        }

        this.setBetValues(arrBetsValue, 0, '.', 0, 99999, 0);

        // TODO: test
        // this.setLabelCredits(10000, this.currencyPrecision, this.currencyDelimiter);
        // this.setModelBet(100, true);
    };

    setOnTotalBetChanged (func) {this.onTotalBetChanged = func;}

    setOnPlaceBet (func) {
        this.buttonPlaceBet.callback = () => {
            this.buttonPlaceBet.enabled = false;
            if (this.config.isMobileMode)
                this.digitalBtnPanelUp.enabled = false;
            if (this.isAccumulateBetMode || this.config.isMobileMode)
                this.buttonClearTotalBet.enabled = false;
            func();
        }
    }

    setOnDigitPanelMove (func) {this.onDigitPanelMove = func;}

    sendPlaceBetEvent () {
        if (this.buttonPlaceBet.enabled) {
            this.sndPlayClick.play();
            this.buttonPlaceBet.callback();
        }
    }

    terminate () {
        this.removeChildren();
        this.destroy();

        this.sndBtnClick.stop();
        this.sndBtnClick = null;
        this.sndPlayClick.stop();
        this.sndPlayClick = null;

        this.layerPanel = null;

        if (this.layerBetButtons.moveTween) this.layerBetButtons.moveTween.stop();
        this.layerBetButtons = null;

        if (this.config.isMobileMode) {
            this.layerBlockInput = null;
            this.backDigitalPanel = null;

            if (this.digitalBtnPanelDown.moveTween) this.digitalBtnPanelDown.moveTween.stop();
            if (this.digitalBtnPanelUp.moveTween) this.digitalBtnPanelUp.moveTween.stop();

            this.digitalBtnPanelDown = null;
            this.digitalBtnPanelUp = null;

            for (let obj of this.arrDigitButtons) obj = null;
            this.arrDigitButtons = null;

            this.digitalBtnClear = null;
            this.digitalBtnEnter = null;

            this.backDownDigitalPanel = null;
        }

        this.backPanel = null;

        for (let obj of this.arrBetsButtons) {
            obj.betLabel = null;
            obj = null;
        }
        this.arrBetsButtons = null;

        this.labelCredits = null;
        this.labelCurrencyCredits = null;
        this.labelTotalBet = null;
        this.labelCurrencyTotalBet = null;

        this.buttonPlaceBet = null;

        if (!this.isNoMinMaxButtons) {
            this.buttonMin = null;
            this.buttonMax = null;
        }

        if (this.isAccumulateBetMode || this.config.isMobileMode) {
            this.buttonClearTotalBet = null;

            if (!this.isNoDivMulButtons) {
                this.buttonDiv = null;
                this.buttonMul = null;
            }
        }

        if (!this.isAccumulateBetMode) {
            this.lightBet.label = null;
            this.lightBet = null;

            if (!this.isNoMinMaxButtons) {
                this.lightBetMin = null;
                this.lightBetMax = null;
            }
        }
    }

    getTotalBet () {
        return this.labelTotalBet.betValue;
    }

    getTotalBetStr () {
        return this.labelTotalBet.text;
    }

    getTotalBetCurrency () {
        return this.labelCurrencyTotalBet.text;
    }

    isLockPlaceBetButton () {
        return !this.buttonPlaceBet.enabled;
    }

    isEnoughCredits () {
        const credits = this.labelCredits.creditsValue;
        return (this.labelTotalBet.betValue > 0 && this.labelTotalBet.betValue <= credits);
    }

    setCurrency (currency) {
        this.currency = currency;
        this.labelCurrencyCredits.text = currency;
        this.labelCurrencyTotalBet.text = currency;
    }

    setLabelCredits (credits, precision, delimiter) {
        this.labelCredits.creditsValue = credits;
        this.labelCredits.text = literal_price_with_check_zero_fractional_part(credits, precision, delimiter);
        this._scaleTextForArea(this.labelCredits, this.widthCreditsTextArea);

        // при изменении кредитов нужно обновить доступные ставки
        this.setModelBet (this.labelTotalBet.betValue, this.isInitState);
    }

    setModelBet (bet, isInitState) {
        bet = getBetValue (bet, this.currencyPrecisionCeil);

        this.isInitState = isInitState;

        this._lockBets();
        this.buttonPlaceBet.enabled = false;
        if (this.config.isMobileMode)
            this.digitalBtnPanelUp.enabled = false;
        if (this.isAccumulateBetMode || this.config.isMobileMode)
            this.buttonClearTotalBet.enabled = false;

        let credits = this.labelCredits.creditsValue;
        let minBet = this.isNoMinMaxButtons ? this.arrBetsButtons[0].betValue : this.minBet;
        let minBetButton = this.isNoMinMaxButtons ? this.arrBetsButtons[0] : this.buttonMin;
        let maxButtonBetValue = this.arrBetsButtons[this.arrBetsButtons.length - 1].betValue;

        // TODO: this.isAccumulateBetMode учитывать прибавку к текщей ставке
        // ищем кнопки для текущей ставки и для максимально возможной
        let btnBet = null;
        let btnBetMaxAvailable = null;
        for (let obj of this.arrBetsButtons) {
            if (obj.visible) {
                let btnBetValue = obj.betValue;
                if (btnBetValue === bet) {
                    btnBet = obj;
                }
                if (btnBetValue <= bet && btnBetValue <= credits) {
                    btnBetMaxAvailable = obj;
                }
            }
        }

        if (!this.isNoMinMaxButtons) {
            if (bet === this.minBet) {
                btnBet = this.buttonMin;
            }
            if (bet === this.maxBet || (bet > maxButtonBetValue && bet <= credits && bet <= this.maxBet)) {
                btnBet = this.buttonMax;
            }
            if (!btnBetMaxAvailable && minBet <= credits) {
                btnBetMaxAvailable = minBetButton;
            }
        }

        if (isInitState) {
            // еще не пришли кредиты от сервера
            if (credits < 0) {
                this._setLabelTotalBet(bet);
                return;
            }

            if (credits < minBet) {
                this._setLabelTotalBet(0);
                return;
            }

            // ставка допустима, но для нее нет кнопки(ввели из цифровой панели или сумма в isAccumulateBetMode)
            if (this.isAccumulateBetMode && !btnBet && bet >= this.minBet && bet<= this.maxBet && bet <= credits) {
                this._setLabelTotalBet(bet);
                this._lightBetVisible(false);
            }
            // если текущая ставка больше кредитов, то скидываем на ближайшую возможную
            else if (bet > credits && btnBetMaxAvailable) {
                if (this.isAccumulateBetMode)
                    this._setBet(btnBetMaxAvailable.betValue);
                else
                    btnBetMaxAvailable.callback(btnBetMaxAvailable);
            }
            // устанавливаем ставку соответсвющей ей кнопкой
            else if (btnBet) {
                if (this.isAccumulateBetMode)
                    this._setBet(btnBet.betValue);
                else
                    btnBet.callback(btnBet);
            }
            else {
                // если сменили счет или не было еще ставок, то ставка minBet или 0
                if (bet <= minBet && bet <= credits && bet > 0 && credits > 0) {
                    if (this.isAccumulateBetMode)
                        this._setBet(minBetButton.betValue);
                    else
                        minBetButton.callback(minBetButton);
                }
            }
        }
        else {
            this._setLabelTotalBet(bet);
            this.buttonPlaceBet.enabled = false;
            if (this.config.isMobileMode) {
                this.digitalBtnPanelUp.enabled = false;
                this.labelPlaceBet.alpha = 0.3;
            }
            if (this.isAccumulateBetMode || this.config.isMobileMode)
                this.buttonClearTotalBet.enabled = false;
        }
    }

    setBetValues (arrBetsValue, precision, delimiter, minBet, maxBet, precisionCeil) {
        if (arrBetsValue.length > this.arrBetsButtons.length) {
            console.error('Count of Bet steps more than count of Bet buttons');
            return;
        }

        this.currencyPrecision = precision;
        this.currencyDelimiter = delimiter;
        this.currencyPrecisionCeil = precisionCeil;

        this.minBet = minBet;
        this.maxBet = maxBet;

        for (let i = 0; i < this.arrBetsButtons.length; ++i) {
            this.arrBetsButtons[i].visible = false;
        }

        // find buttons size for fill all panel area
        const countBet = arrBetsValue.length;
        const panelLength = this.lengthAreaForBetsButtons;
        const buttonLength = this.lengthBetButton;
        const offset = this.offsetBetweenBetButtons;
        const pos = this.startBetButtonsPos;
        const scaleForButton = Math.min(1, panelLength / (buttonLength * countBet + offset * (countBet - 1)));

        let l = 0;
        for (let i = 0; i < arrBetsValue.length; ++i) {
            let btn = this.arrBetsButtons[i];
            if (this.isVerticallyDirection) {
                btn.position.set(pos.x, pos.y - l);
                btn.scale.y = scaleForButton;
            }
            else {
                btn.position.set(pos.x + l, pos.y);
                btn.scale.x = scaleForButton;
            }
            l += buttonLength * scaleForButton + offset;
        }

        // find text scale for max value
        let btn = this.arrBetsButtons[arrBetsValue.length - 1];
        let label = btn.betLabel;
        label.text = literal_price_with_check_zero_fractional_part(arrBetsValue[countBet - 1], precision, delimiter);
        const widthBtn = this.widthBetButtonTextArea * scaleForButton;
        this._scaleTextForArea(label, widthBtn);
        const scaleForText = label.scale.x;

        for (let i = 0; i < arrBetsValue.length; ++i) {
            let btn = this.arrBetsButtons[i];
            let label = btn.betLabel;

            let bet = getBetValue(arrBetsValue[i], precisionCeil);

            label.text = literal_price_with_check_zero_fractional_part(bet, precision, delimiter);
            label.scale.x = scaleForText;

            btn.betValue = bet;
            btn.visible = true;
        }

        if (!this.isNoMinMaxButtons) {
            this.buttonMin.betValue = minBet;
            this.buttonMax.betValue = maxBet;
        }
    }

    panelUp () {
        if (this.isMobileMode)
            this.digitalBtnPanelUp.callback();
    }

    panelDown () {
        if (this.isMobileMode)
            this.digitalBtnPanelDown.callback();
    }

    setLabelPlaceBet (text) {
        if (this.config.isMobileMode) {
            this.labelPlaceBet.text = text;
        }
    }

    getLabelPlaceBet () {
        if (this.config.isMobileMode) {
            return this.labelPlaceBet.text;
        }

        return '';
    }

    _scaleTextForArea (label, widthArea) {
        const widthTxt = label.getLocalBounds().width;
        if (widthTxt > 0)
            label.scale.x = Math.min(1, widthArea/widthTxt);
    }

    _setLabelTotalBet (totalBet) {
        totalBet = getBetValue (totalBet, this.currencyPrecisionCeil);
        this.labelTotalBet.betValue = totalBet;

        this.labelTotalBet.text = totalBet > 0 ? literal_price_with_check_zero_fractional_part(totalBet, this.currencyPrecision, this.currencyDelimiter) : '';
        this.labelCurrencyTotalBet.text = this.currency;

        this._scaleTextForArea(this.labelTotalBet, this.widthTotalBetTextArea);

        this.digitalPanelTotalBetStr = '';
        this.digitalPanelTotalBetVal = 0;

        if (this.isInitState) {
            this._unlockBets();
            this._tryUnlockPlaceBet();
        }

        this.onTotalBetChanged(this.labelTotalBet.text, this.labelCurrencyTotalBet.text);
    }

    _setBet(bet){
        if (bet < this.minBet || bet > this.maxBet || bet > this.labelCredits.creditsValue)
            return false;

        this._setLabelTotalBet(bet);
        return true;
    }

    _onBetButton(button) {
        let newBet = button.betValue;
        if (this.isAccumulateBetMode) {
            newBet += this.digitalPanelTotalBetStr.length === 0 ? this.labelTotalBet.betValue : this.digitalPanelTotalBetVal;
        }

        if (this._setBet(newBet))
            this._lightBet(button);
    }

    _onBetButtonMin(button) {
        if (this._setBet(button.betValue))
            this._lightBet(button, true, false);
    }

    _onBetButtonMax(button) {
        // округлять к наименьшему если задано this.currencyPrecisionCeil
        button.betValue = Math.min(this.maxBet, round_price(this.labelCredits.creditsValue, this.currencyPrecisionCeil, false));
        if (this._setBet(button.betValue))
            this._lightBet(button, false, true);
    }

    _onButtonDiv() {
        // округлять можно только при делении/умножении и потенциальный выигрыш(это для игр типа лесенка)
        let newBet = round_price(Math.ceil(this.labelTotalBet.betValue / 2), this.precisionCeil);
        this._setBet(newBet);
    }

    _onButtonMul() {
        // округлять можно только при делении/умножении и потенциальный выигрыш(это для игр типа лесенка)
        let newBet = round_price(this.labelTotalBet.betValue * 2, this.precisionCeil);
        this._setBet(newBet);
    }

    _lightBet(betButton, isMinBet = false, isMaxBet = false) {
        if (!this.isAccumulateBetMode) {
            this.lightBet.visible = false;
            let lightBet = this.lightBet;

            if (!this.isNoMinMaxButtons) {
                this.lightBetMin.visible = this.lightBetMax.visible = false;

                if (isMinBet)
                    lightBet = this.lightBetMin;
                if (isMaxBet)
                    lightBet = this.lightBetMax;
            }

            lightBet.visible = true;
            lightBet.position = betButton.position;
            lightBet.scale.x = betButton.scale.x;

            if (lightBet.label) {
                lightBet.label.text = betButton.betLabel.text;
                lightBet.label.scale.x = betButton.betLabel.scale.x;
            }
        }
    }

    _lightBetVisible(isVisible) {
        if (!this.isAccumulateBetMode) {
            this.lightBet.visible = isVisible;
            if (!this.isNoMinMaxButtons) {
                this.lightBetMin.visible = isVisible;
                this.lightBetMax.visible = isVisible;
            }
        }
    }

    _lockBets () {
        for (let obj of this.arrBetsButtons) {
            obj.enabled = false;
            obj.betLabel.alpha = 0.5;
        }

        if (!this.isNoMinMaxButtons) {
            this.buttonMin.enabled = false;
            this.buttonMax.enabled = false;
        }

        if (!this.isNoDivMulButtons) {
            this.buttonDiv.enabled = false;
            this.buttonMul.enabled = false;
        }
    }

    _unlockBets () {
        let credits = this.labelCredits.creditsValue;
        let totalBet = 0;
        if (this.isAccumulateBetMode) {
            totalBet = this.digitalPanelTotalBetStr.length === 0 ? this.labelTotalBet.betValue : this.digitalPanelTotalBetVal;
        }
        for (let obj of this.arrBetsButtons) {
            let isUnlock = obj.betValue <= credits;
            if (this.isAccumulateBetMode) {
                isUnlock = (obj.betValue + totalBet <= credits) && (obj.betValue + totalBet <= this.maxBet);
            }
            if (isUnlock){
                obj.enabled = true;
                obj.betLabel.alpha = 1;
            }
            else {
                obj.enabled = false;
                obj.betLabel.alpha = 0.5;
            }
        }

        if (!this.isNoMinMaxButtons) {
            this.buttonMin.enabled = this.buttonMin.betValue <= credits;
            this.buttonMax.enabled = this.buttonMin.betValue <= credits;

            if (this.isAccumulateBetMode) {
                this.buttonMin.enabled = this.buttonMin.enabled && this.buttonMin.betValue !== totalBet;
                this.buttonMax.enabled = this.buttonMax.enabled && this.buttonMax.betValue !== totalBet;
            }
        }

        if (!this.isNoDivMulButtons) {
            const divTotalBet = round_price(Math.ceil(totalBet / 2), this.currencyPrecisionCeil);
            const mulTotalBet = round_price(totalBet * 2, this.currencyPrecisionCeil);
            this.buttonDiv.enabled = divTotalBet >= this.buttonMin.betValue;
            this.buttonMul.enabled = mulTotalBet > 0 && mulTotalBet <= this.buttonMax.betValue && mulTotalBet <= credits;
        }


        if (this.isAccumulateBetMode || this.config.isMobileMode)
            this.buttonClearTotalBet.enabled = this.digitalPanelTotalBetStr.length > 0 || this.labelTotalBet.length > 0;
    }

    _tryUnlockPlaceBet() {
        // так как _tryUnlockPlaceBet вызывается только в Init
        if (this.config.isMobileMode)
            this.digitalBtnPanelUp.enabled = true;

        let isEnoughCredits = this.isEnoughCredits();

        if (this.isAccumulateBetMode || this.config.isMobileMode)
            this.buttonClearTotalBet.enabled = isEnoughCredits;

        this.buttonPlaceBet.enabled = isEnoughCredits;

        if (this.config.isMobileMode) {
            this.labelPlaceBet.alpha = isEnoughCredits ? 1.0 : 0.3;
        }

        if (!this.isAccumulateBetMode) {
            this.lightBet.visible = isEnoughCredits && this.lightBet.visible;
            if (!this.isNoMinMaxButtons) {
                this.lightBetMin.visible = isEnoughCredits && this.lightBetMin.visible;
                this.lightBetMax.visible = isEnoughCredits && this.lightBetMax.visible;
            }
        }
    }
}

const resourcesUiPanel_mobile_vertical = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            "res/common/minigames/sounds/btn_click",
            "res/common/minigames/sounds/play_click",
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/common/minigames/panel/mobile_vertical/common.json",
            {name: "res/common/minigames/panel/mobile_vertical/panel.json", rus: true},

            "res/common/minigames/panel/mobile_vertical/fonts/font_bet_panel_mobile_vertical.xml",
            "res/common/minigames/panel/mobile_vertical/fonts/font_bet_light_panel_mobile_vertical.xml",
            "res/common/minigames/panel/mobile_vertical/fonts/font_credits_panel_mobile_vertical.xml",
            "res/common/minigames/panel/mobile_vertical/fonts/font_currency_panel_mobile_vertical.xml",
            "res/common/minigames/panel/mobile_vertical/fonts/font_currency_bet_panel_mobile_vertical.xml",
            "res/common/minigames/panel/mobile_vertical/fonts/font_place_button_bet_panel_mobile_vertical.xml",
        ]
};

export const configUiPanel_mobile_vertical = {
    resources: resourcesUiPanel_mobile_vertical,
    packFolder: "minigames_panel_mobile_vertical/",
    sndBtnClick: "res/common/minigames/sounds/btn_click",
    sndBtnPlay: "res/common/minigames/sounds/play_click",
    screenWidth: 540,
    screenHeight: 900,
    isMobileMode: true,                                 // if false - not need res folders digital_panel
    isAccumulateBetMode: true,                          // if false - not need res folders 2div, 2mul, clear, if true - not need light texture in folders bet, min_bet, max_bet
    isNoMinMaxButtons: false,                           // if true - not need res folders min_bet, max_bet
    isNoDivMulButtons: true,                            // if true - not need res folders 2div, 2mul
    isHideTotalBet: false,                              // если нужно скрыть валюту и ставку и выводить ее иначе
    isHideCurrencyCredits: false,                       // если нужно скрыть валюту кредитов
    balanceTabPosition: {x: 194, y: 27},
    buttonPlaceBetText: 'FLIP',                         // текст на кнопке для мобильной панели
    buttonPlaceBetTextScale: {x: 1.0, y: 1.0},
    buttonPlaceBetTextPos: {x: 84, y: 31},
    buttonPlaceBetPosition: {x: 165, y: 13},
    buttonClearTotalBetPosition: {x: 465, y: 13},
    buttonDivPosition: {x: 49, y: 221},
    buttonMulPosition: {x: 298, y: 221},
    buttonMinPosition: {x: 85, y: 13},
    buttonMaxPosition: {x: 3, y: 13},
    widthTotalBetTextArea: 127,
    widthCreditsTextArea: 140,
    widthBetButtonTextArea: 63,                         // ширина области для вывода текста(для скалирования текста если не помещается)
    lengthAreaForBetsButtons: 533,                      // ширина(высота) области для размещения кнопок ставок(скалирование кнопок для заполнения всей области)
    lengthBetButton: 81,                                // ширина(высота) кнопки
    offsetBetweenBetButtons: 0,                         // отступ между кнопками
    startBetButtonsPos: {x: 1, y: 810},                 // координаты первой кнопки
    isVerticallyDirection: false,                       // вертикально или горизонтально идут кнопки
    labelCredits: {
        pos: {x: 74, y: 33},
        font: {
            name: "font_credits_panel_mobile_vertical"
        }
    },
    labelCurrencyCredits: {
        pos: {x: 85, y: 1},
        font: {name: "font_currency_panel_mobile_vertical"}
    },
    labelTotalBet: {
        pos: {x: 403, y: 34},
        font: {name: "font_credits_panel_mobile_vertical"}
    },
    labelCurrencyTotalBet: {
        pos: {x: 379, y: 2},
        font: {
            name: "font_currency_bet_panel_mobile_vertical",
            align: "left",
            anchor: {x: 0.0, y: 0.0},
            tint: 0x000000
        }
    },
    labelBetButton: {
        pos: {x: 41, y: 29},
        font: {name: "font_bet_panel_mobile_vertical"}
    },
    labelBetLight: {
        pos: {x: 41, y: 29},
        font: {name: "font_bet_light_panel_mobile_vertical"}
    },
};


// WEBPACK FOOTER //
// ./src/library/minigame_client/ui/panel.es6